import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'

const axiosRequest = (extraParams: any = {}) =>
  AxiosInitializer({
    token: getToken(),
    paramsSerializerConfig: true,
    ...extraParams,
  })

const pinnedItemsAPI = {
  get: (projectId: string, params = {}) =>
    apiWrapper({
      endPoint: () =>
        axiosRequest({ transformResConfig: false }).get(
          `/projects/${projectId}/pinned_items`,
          {
            params,
          },
        ),
      params,
      errorFailureAction: handleStatus500,
    }),
  post: (projectId: string, name: string, pinnableType: string, params = {}) =>
    apiWrapper({
      endPoint: () =>
        axiosRequest({ transformResConfig: false }).post(
          `/projects/${projectId}/pinned_items`,
          {
            data: {
              attributes: {
                name,
                'pinnable-type': pinnableType,
              },
            },
          },
        ),
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default pinnedItemsAPI
